module.exports = __webpack_public_path__ + "img/bg-pop-up.921f8f4a.png";